import React from 'react';
import { t } from '@sm/intl';

const COPY = {
  pageTitle: {
    id: 'pricingweb.PricingSummary.pageTitle',
    defaultMessage: 'SurveyMonkey Plans and Pricing',
    description: '[Type: Label][Vis: med] - Page title for Pricing pages',
  },
  pageDescription: {
    id: 'pricingweb.PricingSummary.pageDescription',
    defaultMessage:
      'Create and publish online surveys in minutes, and view results graphically and in real time. SurveyMonkey provides free online questionnaire and survey software.',
    description: '[Type: Label][Vis: med] - Page meta description for pricing pages',
  },
  pageKeywords: {
    id: 'pricingweb.PricingSummary.pageKeywords',
    defaultMessage:
      'questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys',
    description: '[Type: Label][Vis: med] - Page meta keywords for pricing pages. Includes deliberate misspellings',
  },
};

const RequiredHeadTags = () => {
  return (
    <>
      <title data-testid="RequiredHeadTags__Title">{t(COPY.pageTitle)}</title>
      <meta data-testid="RequiredHeadTags__Keywords" name="keywords" content={t(COPY.pageKeywords)} />
      <meta data-testid="RequiredHeadTags__Desc" name="description" content={t(COPY.pageDescription)} />
    </>
  );
};

export default RequiredHeadTags;
